export default __webpack_public_path__ + "static/media/round-text.19d830f0.svg";